module.exports = __webpack_public_path__ + "static/media/Maf_Inver.a0d7f921.jpg";